export enum BlockDragAndDropFormats {
  BlockDrag = 'blockDrag',
  BlockReorder = 'blockReorder',
  ImageDrag = 'imageData'
}

export enum BlockKeys {
  CreatedAt = 'createdAt',
  Data = 'data',
  DeletedAt = 'deletedAt',
  Key = 'key',
  Locale = 'locale',
  PageKey = 'pageKey',
  ParentKey = 'parentKey',
  Position = 'position',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export enum BlockDataPdfKeys {
  CdnUrl = 'cdnUrl',
  Description = 'description',
  EmbedMode = 'embedMode',
  Height = 'height',
  Key = 'key',
  Name = 'name',
  Width = 'width'
}

export enum BlockDataColorKeys {
  Data = 'data',
  Description = 'description',
  Key = 'key',
  Name = 'name'
}

export enum BlockDataColorDataKeys {
  B = 'b',
  C = 'c',
  G = 'g',
  Hex = 'hex',
  K = 'k',
  M = 'm',
  Pantone = 'pantone',
  PantoneUncoated = 'pantone_u',
  R = 'r',
  Y = 'y'
}

export enum BlockDataHtmlKeys {
  Html = 'html'
}

export enum BlockDataImageKeys {
  CdnUrl = 'cdnUrl',
  Description = 'description',
  Height = 'height',
  Key = 'key',
  Name = 'name',
  ThumbnailUrl = 'thumbnailUrl',
  Width = 'width'
}

export enum BlockDataSectionKeys {
  Id = 'id',
  Name = 'name'
}

export enum BlockTypes {
  Color = 'color',
  Html = 'html',
  Image = 'image',
  Pdf = 'pdf',
  Section = 'section',
  Text = 'text'
}

export enum PdfEmbedModes {
  Inline = 'IN_LINE',
  SizedContainer = 'SIZED_CONTAINER'
}
